import { makeStyles } from '@material-ui/core'
import { Typography } from '@paintscout/ui'
import moment from 'moment'
import React from 'react'
import type { HeaderProps } from 'react-big-calendar'

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    height: '70px'
  }
}))

export function WeekColumnHeader(props: HeaderProps) {
  const classes = useStyles()
  const momentDate = moment(props.date)
  return (
    <div className={classes.root}>
      <Typography>{momentDate.format('ddd')}</Typography>
      <Typography weight={400} variant="h3" color="inherit">
        {momentDate.format('D')}
      </Typography>
    </div>
  )
}
